/* 🤖 this file was generated by svg-to-ts */
export const nsClose: {
  name: 'close';
  data: string;
} = {
  name: 'close',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path d="M18 5.4 16.6 4 11 9.6 5.4 4 4 5.4 9.6 11 4 16.6 5.4 18l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L18 5.4Z"/></svg>`
};
